module.exports = __webpack_public_path__ + "static/img/t-sample02.9dcdffde.svg";